import Phaser from "phaser";
import { Unit } from "./Unit";

export type ProjectileConfig = {
  x: number;
  y: number;
  target: Unit;
  damage: number;
  texture: string;
  speed?: number;
  splashRadius?: number;
  slow?: number;
  onHit?: (target: Unit, projectile: Projectile) => void;
};

export class Projectile {
  readonly sprite: Phaser.GameObjects.Image;
  readonly target: Unit;
  readonly damage: number;
  readonly speed: number;
  readonly splashRadius: number;
  readonly slow: number;
  readonly onHit?: (target: Unit, projectile: Projectile) => void;
  active = true;

  constructor(scene: Phaser.Scene, config: ProjectileConfig) {
    this.target = config.target;
    this.damage = config.damage;
    this.speed = config.speed ?? 420;
    this.splashRadius = config.splashRadius ?? 0;
    this.slow = config.slow ?? 0;
    this.onHit = config.onHit;
    this.sprite = scene.add.image(config.x, config.y, config.texture).setDepth(70).setScale(0.76);
  }

  update(deltaMs: number) {
    if (!this.active) return;
    if (!this.target.alive) {
      this.destroy();
      return;
    }

    const angle = Phaser.Math.Angle.Between(this.sprite.x, this.sprite.y, this.target.x, this.target.y);
    const distance = (this.speed * deltaMs) / 1000;
    this.sprite.x += Math.cos(angle) * distance;
    this.sprite.y += Math.sin(angle) * distance;
    this.sprite.rotation = angle;

    if (Phaser.Math.Distance.Between(this.sprite.x, this.sprite.y, this.target.x, this.target.y) < 12) {
      this.onHit?.(this.target, this);
      this.destroy();
    }
  }

  destroy() {
    this.active = false;
    this.sprite.destroy();
  }
}
